// extracted by mini-css-extract-plugin
module.exports = {"view":"StudyView_view__2DvxJ","edit":"StudyView_edit__11GBp","doctor-card":"StudyView_doctor-card__2rS3Z"};